import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchMe, tokenStore, verifyMagicLink, activeProfile } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!tokenStore.get()) {
      setUser(null);
      return null;
    }
    try {
      const me = await fetchMe();
      setUser(me);
      return me;
    } catch {
      tokenStore.clear();
    activeProfile.clear();
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      await refresh();
      setReady(true);
    })();
  }, [refresh]);

  const completeSignIn = useCallback(async (token) => {
    const data = await verifyMagicLink(token);
    activeProfile.clear();
    tokenStore.set(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  // Complete sign-in from a password login / register / reset response
  // ({ access_token, user }) — persists the session and hydrates the user.
  const completeTokenSignIn = useCallback((data) => {
    activeProfile.clear();
    tokenStore.set(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const signOut = useCallback(() => {
    tokenStore.clear();
    activeProfile.clear();
    setUser(null);
  }, []);

  const value = { user, ready, refresh, completeSignIn, completeTokenSignIn, signOut, setUser };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}
